import axios from 'axios';

/**
 * Tüm API isteklerine oturum token'ını ekler (Authorization: Bearer ...).
 * Sunucu artık kullanıcıyı istekteki "username" alanından değil bu token'dan tanır.
 * Uygulama başlamadan önce (index.js) bir kez kurulur ki ilk istekler de token taşısın.
 */
const isOwnApi = (url) => {
  if (!url) return true;
  if (url.startsWith('/')) return true;
  try {
    return new URL(url, window.location.origin).origin === window.location.origin;
  } catch {
    return false;
  }
};

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token && isOwnApi(config.url)) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});
